const languageNames = typeof Intl.DisplayNames === "function" ? new Intl.DisplayNames(["en"], { type: "language" }) : null;

// Non-English articles arrive machine-translated; name the source language.
export function translatedFrom(language) {
  if (!language || language === "en") return undefined;
  try {
    return languageNames?.of(language) || language;
  } catch {
    return language;
  }
}
